import axios from "axios";

const configuredBackend = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, "");
const BACKEND_URL = configuredBackend || (
  process.env.NODE_ENV === "development"
    ? "http://localhost:8000"
    : "https://api.callsect.com"
);

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !err?.config?.skipAuthRedirect) {
      localStorage.removeItem("cs_token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    if (
      err?.response?.status === 428 &&
      err?.response?.data?.detail?.code === "legal_acceptance_required" &&
      window.location.pathname !== "/legal-consent"
    ) {
      window.location.href = "/legal-consent";
    }
    return Promise.reject(err);
  }
);
